import './App.css';
import Layout from './Component/Common/Layout';
import Home from './Component/Home';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Admin from './Component/Admin';
import Login from './Login';
import Register from './Register';
import Cart from './Component/cart';
import Aboutus from './Component/Aboutus';
import ProductView from './Component/ProductView';
import ScrollToTop from "./Component/ScrollToTop";


function App() {
  return (
    <div className="App">
      <Layout>
        <ScrollToTop/>
          <Routes>
            <Route path='/' exact element={<Home />} />
             <Route path='/Admin' element={<Admin/>}/>
             <Route path='/login' element={<Login/>}/>
             <Route path='/register' element={<Register/>}/>
             <Route path='/cart' element={<Cart/>}/>
             <Route path='/about' element={<Aboutus/>}/>
             <Route path="/product/:id" element={<ProductView />} />
          </Routes>
        
      </Layout>
    </div>

/* <AppoloProvider>
  <Cart/>
</AppoloProvider> */

  );
}

export default App;
